document.addEventListener('DOMContentLoaded', function () {
  new Swiper('.offer-slider', {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    autoplay: { delay: 3000, disableOnInteraction: false },
    pagination: {
      el: '.swiper-pagination',
      type: 'fraction'
    }
  });

  document.querySelectorAll('.offer-slide').forEach(function (slide) {
    slide.addEventListener('click', function () {
      var codeEl = slide.querySelector('.offer-details span');
      if (!codeEl) return;
      var code = codeEl.textContent.replace('Use Code: ', '').trim();
      navigator.clipboard.writeText(code);
      var original = codeEl.textContent;
      codeEl.textContent = 'Copied to clipboard!';
      setTimeout(function () { codeEl.textContent = original; }, 1500);
    });
  });
});